<template>
  <div class="search-bar">
    <input
      v-model="query"
      class="search-input"
      type="text"
      :placeholder="placeholder"
      @keyup="sendQueryToParent()"
    />
    <magnifying-glass class="search-icon"></magnifying-glass>
  </div>
</template>

<script>
import MagnifyingGlass from "@/assets/svg/magnifying-glass.svg?inline";
import { normalizeString } from "@/utils/stringNormalize";

export default {
  components: {
    MagnifyingGlass,
  },
  props: {
    preselectedQuery: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      query: this.preselectedQuery,
    };
  },
  watch: {
    preselectedQuery(newVal) {
      this.query = newVal;
    },
  },
  created() {
    this.query = this.preselectedQuery;
  },
  methods: {
    sendQueryToParent() {
      const normalizedQuery = normalizeString(this.query);
      this.$emit("query", normalizedQuery);
    },
  },
};
</script>

<style lang="scss" scoped>
.search-bar {
  margin: 16px auto;
  display: flex;
  justify-content: space-evenly;
  position: relative;
  width: 80%;
}

.search-input {
  width: 100%;
  height: 30px;
  @include input-style;
  padding: 3px 8px 3px 8px;
  &::placeholder {
    color: rgba(196, 196, 196, 1);
    font-size: 12px;
  }
}

.search-icon {
  position: absolute;
  right: 8px;
  bottom: 6px;
}
</style>
